import RemoteIconV2 from '@/components/Icon/RemoteIconV2';
import type {AutoDeliveryFrequency} from '@/consts/icc/iccAutoDeliveryStatusTypes';
import appContent from '@/services/content/appContent.typed';
import stringUtils from '@/utils/stringUtils';
import {getAutoDeliveryDcxFrequencyLabelFromAppContent} from '@/views/AutoDeliveryDcx/helpers/autoDeliveryDcxFrequency.helpers';

interface AutoDeliveryDcxOrderFrequencyProps {
    frequency?: AutoDeliveryFrequency;
    minDeliveryDaysCount?: number;
    maxDeliveryDaysCount?: number;
}

const AutoDeliveryDcxOrderFrequency = (props: AutoDeliveryDcxOrderFrequencyProps) => {
    const {frequency, minDeliveryDaysCount, maxDeliveryDaysCount} = props;
    const {orderFrequencyTitle, orderFrequencyIcon, orderFrequencyDescription} =
        appContent.getAutoDeliveryContent().dashboardContent;
    const frequencyLabel = frequency ? getAutoDeliveryDcxFrequencyLabelFromAppContent(frequency) : undefined;
    const formattedOrderFrequencyDescription = stringUtils.formatString(
        orderFrequencyDescription,
        minDeliveryDaysCount,
        maxDeliveryDaysCount
    );

    return (
        <div className='flex flex-col gap-1'>
            {orderFrequencyTitle && frequencyLabel && (
                <>
                    <span className='text-14 leading-[20px]'>{orderFrequencyTitle}</span>
                    <span className='text-20 font-bold leading-[28px]'>{frequencyLabel}</span>
                </>
            )}
            {formattedOrderFrequencyDescription && (
                <div className='flex items-center gap-1'>
                    <RemoteIconV2 icon={orderFrequencyIcon} className='size-6' />
                    <span className='text-12 leading-[16px]'>{formattedOrderFrequencyDescription}</span>
                </div>
            )}
        </div>
    );
};

export default AutoDeliveryDcxOrderFrequency;
